import { DirectMessagingAction } from '../_constants';
export const DirectMessagingActions = {
  addMsg,
  addClient,
  addBEMsg,
  initGroup,
  newGroup
};
function addMsg(item) {
  return { type: DirectMessagingAction.NEW_MSG, item };
}
function addBEMsg(item) {
  return { type: DirectMessagingAction.NEW_MSG_FC, item };
}
function addClient(client) {
  return { type: DirectMessagingAction.NEW_CLIENT, client };
}
function initGroup(groups) {
  return { type: DirectMessagingAction.INIT_GROUP, groups };
}
function newGroup(item) {
  return { type: DirectMessagingAction.NEW_GROUP, item };
}
